import { TableHead, TableRow, TableCell } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { UserGroups } from '@/types'
import { AuthorizationGuard } from '@/components'

const columnNames = [
  'projectName',
  'id',
  'business',
  'startDate',
  'endDate',
  'progress',
  'status',
]

const columnNamesClient = columnNames.filter((c) => c !== 'progress')

export const ProjectsTableHead = (): JSX.Element => {
  const { t } = useTranslation('projects')

  return (
    <TableHead sx={{ borderRadius: 8 }}>
      <TableRow>
        <AuthorizationGuard
          allowedGroups={[UserGroups.MANAGER]}
          redirect={false}
          fallback={
            <>
              {columnNamesClient.map((columnName) => (
                <TableCell key={columnName}>
                  {t(`columnNames.${columnName}`)}
                </TableCell>
              ))}
            </>
          }
        >
          {columnNames.map((columnName) => (
            <TableCell key={columnName}>
              {t(`columnNames.${columnName}`)}
            </TableCell>
          ))}
        </AuthorizationGuard>
        <TableCell />
      </TableRow>
    </TableHead>
  )
}
